import React, { useContext } from "react";
import PageWrapper from "./PageWrapper";
import Home from "./Home/Home";
import LandingPage from "./LandingPage";
import { Redirect } from "react-router-dom";
import { configStore } from "../../contexts/ConfigContext";
import { errorStore } from "../../contexts/ErrorContext";
import { useFeatureFlag } from "@evidenceb/athena-common/modules/FeatureFlags";
import { Pagetype } from "../../interfaces/Config";

const TeacherHomeResolver = () => {
    const {
        config: { pages },
    } = useContext(configStore);
    const { setErrorInfo } = useContext(errorStore);
    const adsecNavigationFlag = useFeatureFlag("adsecNavigation");
    const { config } = useContext(configStore);

    const homePage = pages.find((page) => page.type === Pagetype.HOME);
    if (!homePage) {
        setErrorInfo({ displayModal: false, page: { code: "config" } });
        return null;
    }

    const fallback = homePage.fallback?.teacher;
    if (fallback) return <Redirect to={`/${fallback}`} />;

    return (
        <PageWrapper>
            {config.auth?.mode === "REGISTER" ||
            config.auth?.mode === "REGISTER_NAMEONLY" ? (
                <Home />
            ) : adsecNavigationFlag ? (
                <LandingPage />
            ) : (
                <Home />
            )}
        </PageWrapper>
    );
};
export default TeacherHomeResolver;
